/**
 * Parse extension authentication parameters from URL search params
 * @param {URLSearchParams|string} searchParams - URL search params or search string
 * @returns {object|null} Extension auth options or null if not extension auth
 */
export function parseExtensionAuthParams(searchParams) {
  const params = typeof searchParams === 'string'
    ? new URLSearchParams(searchParams)
    : searchParams;

  const authSource = params.get('auth_source');

  if (authSource !== 'chrome_extension') {
    return null;
  }

  return {
    authSource: 'chrome_extension',
    deviceId: params.get('ext_device_id')?.trim() || undefined,
    deviceName: params.get('ext_device_name')?.trim() || undefined,
    extensionVersion: params.get('ext_version')?.trim() || undefined,
  };
}
